export default "__VITE_ASSET__Dut7gts___"